export function toCamelCase(string) {
  return string
    .replace(/[^a-zA-Z0-9]+(.)?/g, (_, character) => character ? character.toUpperCase() : '')
    .replace(/^./, match => match.toLowerCase());
}

export function toPx(rem, root = getRoot()) {
  return `${parseFloat(rem) * root}px`;
}

export function toRem(px, root = getRoot()) {
  return `${parseFloat(px) / root}rem`;
}

function getRoot() {
  return parseFloat(getComputedStyle(document.documentElement).fontSize);
}
